import { Column } from 'ag-grid-community';
import { PeriodRendererParams } from '@core/typings/period-renderer.params';
import { TimerUtils } from '@portal-shared/app/utils/timer.utils';
import { MinimalAssignmentPeriodDto } from '@services/dtos/rows/minimal-assignment-period.dto';
import { AssignmentRow } from '@shared/components/grids/rows/assignments/assignment-row';
import { EditRequestModel } from './edit-request.model';

export class AssignmentPeriodCellRendererHelper {
  private static editRequest?: EditRequestModel;

  public static scheduleEditCell(editRequest: EditRequestModel) {
    this.editRequest = editRequest;
    setTimeout(() => {
      AssignmentPeriodCellRendererHelper.editRequest = undefined; // clear the request if not refreshed right away
    }, TimerUtils.humanThresholdMs);
  }

  public static handleEditRequest(params: PeriodRendererParams<AssignmentRow, MinimalAssignmentPeriodDto>) {
    const request = AssignmentPeriodCellRendererHelper.editRequest;

    if (
      !request || // no request
      params.value?.periodId !== request.periodId ||
      params.node.id !== request.rowId // period id or row id mismatch
    )
      return; // only verify requests when a period ids match and are defined

    AssignmentPeriodCellRendererHelper.editRequest = undefined;
    if (params.column) {
      setTimeout(() => {
        params.api.startEditingCell({
          colKey: params.column as Column,
          rowIndex: params.node.rowIndex ?? 0
        });
      }, TimerUtils.humanThresholdMs);
    }
  }
}
